export default __webpack_public_path__ + "static/media/physicalruin.c37e23bc.png";